import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
//import { useSelector } from 'react-redux';
import { Paper, Grid, Box, Typography, Stack, Link, IconButton, Button, Divider } from '@mui/material';
//import BreadCumControl from './Controls/BreadcumControl';
//import EnrollmentBanner from './EnrollmentBanner';
import { Footer } from './Footer';
import PersonalInfoSection from './PersonalInfoSection';
import ProfileChangePassword from './ProfileChangePassword';
import ProfileRecentActivity from './ProfileRecentActivity';
import ProfilePreferences from './ProfilePreferences';
//import SecuritSection from './Profile/SecuritSection';
import PostLoginMenu from './PostLoginMenu'
import Container from '@mui/material/Container';
import OverlaySpinner from './Controls/OverlaySpinner';
import { DrawerAppBar } from './AppNavbar'
//import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import EnrollmentHeader from './EnrollmentHeader'
//import pwdimg from '../assets/images/457.jpg';
//import Image from 'material-ui-image'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import { pink, grey } from '@mui/material/colors';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import { GetLoggedInUserId, GetLoggedInUserEmail, CallAPI } from '../global/APIUtils';
import profimg from '../assets/images/profimg.jpg';
import ProfilePicUpdDlg from '../dialogs/ProfilePicUpdDlg';
import { ErrorMessages } from '../common/ErrorMessages';
import { LoadProfilePic } from '../global/Helpers';
import AlertControl from './Controls/AlertControl';
import { APICall } from '../global/Api';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: 0,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const UserProfileSetting = (props) => {

    let sections = {
        personalInfo: 1,
        changePassword: 2,
        recentActivity: 3,
        preferences: 4
    };
    const location = useLocation();
    /*const { cntCtId, emailAdrs } = route.params;*/
    //const cntCtId = useRef(location.state.userId || -1);
    const emailAdrs = useRef(null);
    //const userNm = useRef(null);
    //const selectedSection = useRef(sections.personalInfo);

    //const [cntCtId] = useState(location.state.CntCtId);
    //const [emailAdrs] = useState(location.state.EmailAdrs);
    const [selectedSection, setSelectedSection] = useState(sections.personalInfo);
    const [isLoading, setIsLoading] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const [userNm, setUserNm] = useState('');
    const [imageUrl, setImageUrl] = useState(null);
    const [showImageDlg, setShowImageDlg] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const [userId, setUserId] = useState(location.state.userId || -1);
    const [sessionId, setSessionId] = useState(location.state.sessionId || '');

    //let sessions = useSelector((state) => state.sessionMgmnt);

    const loadScreen = async () => {

        try {

            setIsLoading(true);

            let apiImageUrl = new URL(
                process.env.REACT_APP_GET_PROFILE_IMAGE,
                process.env.REACT_APP_BASE_URL,
            );

            apiImageUrl.searchParams.set('cntctId', `${parseInt(userId)}`);

            let response = await APICall({ url: apiImageUrl.href, method: 'GET', contentType: 'application/json', responseType: 'blob' }, userId, sessionId);

            if (response) {
                if (response.type == 'image/jpeg') {
                    setImageUrl(response);
                }
                else {
                    setImageUrl(null);
                }
                setIsLoading(false);
            }
        }
        catch (err) {
            setErrorMsg(ErrorMessages.UnknownError);
            setIsLoading(false);
        }
        finally {
        }
    }

    useEffect(() => {

        emailAdrs.current = GetLoggedInUserEmail(userId, sessionId);

        loadScreen();

    }, []);

    const handleAccordianChange = () => {
        if (expanded) {
            setExpanded(false);
        }
        else {
            setExpanded(true);
        }
    }

    const onClickHandlePic = (event) => {
        event.preventDefault();
        setShowImageDlg(true);
    }
    const closeImageDlg = () => {
        //event.preventDefault();
        setShowImageDlg(false);
    }

    const onPicChangeHandle = async () => {
        setShowImageDlg(false);

        try {

            setIsLoading(true);

            let apiImageUrl = new URL(
                process.env.REACT_APP_GET_PROFILE_IMAGE,
                process.env.REACT_APP_BASE_URL,
            );

            apiImageUrl.searchParams.set('cntctId', `${parseInt(userId)}`);

            let response = await APICall({ url: apiImageUrl.href, method: 'GET', contentType: 'application/json', responseType: 'blob' }, userId, sessionId);

            if (response) {
                if (response.type == 'image/jpeg') {
                    setImageUrl(response);
                }
                else {
                    setImageUrl(null);
                }
                setIsLoading(false);
            }
        }
        catch (err) {
            setErrorMsg(ErrorMessages.UnknownError);
            setIsLoading(false);
        }
        finally {
        }
    }

    return (
        <React.Fragment>
            <Container maxWidth="xl" sx={{}}>
                <OverlaySpinner disappear={isLoading} />
                <PostLoginMenu userId={userId} sessionId={sessionId} />
                <Paper className=""
                    sx={{
                        position: 'relative',
                        backgroundColor: '#fff',
                        color: '#fff',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        pb: 12
                    }}
                >
                    <Grid item>
                        <Box sx={{
                            pr: { xs: 3, md: 2 },
                            pl: { xs: 3, md: 2 }
                        }}>
                            <Accordion spacing={0} elevation={0} expanded={expanded} onChange={handleAccordianChange} sx={{ p: 0, m: 0, width: '100%' }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" sx={{ mr: 2 }}>
                                </AccordionSummary>
                                <AccordionDetails sx={{ pr: 2, pl: 0, pb: 0 }}>
                                    {/*<EnrollmentHeader />*/}
                                    <DrawerAppBar userId={userId} sessionId={sessionId} />
                                </AccordionDetails>
                            </Accordion>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ ml: 6, mr: 6, border: '0px solid #000', pt: 1 }}>
                            <Typography variant="h3" color="text.primary" sx={{ borderBottom: '1px solid rgba(0,0,0,0.1)', lineHeight: 2.2, fontWeight: 500, letterSpacing: '-1px', textAlign: 'center' }} >Profile Information</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs container spacing={0} sx={{ pt: 1 }}>
                            <Grid item xs={12} sx={{}}>
                                <Box sx={{ pr: 10, pl: 15,  }}>
                                    {/*<Box sx={{ border: '0px solid #000', pt: 0 }}>*/}
                                    {/*    <Typography variant="h3" color="text.primary" sx={{ borderBottom: '1px solid rgba(0,0,0,0.1)', lineHeight: 2.2, fontWeight: 500, letterSpacing: '-1px', textAlign: 'center' }} >Profile Information</Typography>*/}
                                    {/*</Box>*/}
                                    <Grid item xs container direction="row" spacing={2} sx={{ pt: 0, pb: 0 }}>
                                        <Grid item md={9} sx={{ pr: 5}} justifyContent="center">
                                            <AlertControl Message={errorMsg} severity="error" color="error" icon={true} />
                                            <Box sx={{ pt: 2, pr: 0, ml: 10 }}>
                                                <Typography sx={{ mt: 1, pb: 0, fontWeight: 400, lineHeight: 1.3 }} variant="h6" color="text.secondary">
                                                    Manage your personal information, privacy, and security to make the application work better for you. This dashboard provides access to your account information.
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item md={2}>
                                            <Box className="text-center" sx={{ pt: 5 }}>
                                                {imageUrl ?
                                                    <img style={{ cursor: 'pointer', }} onClick={onClickHandlePic} src={URL.createObjectURL(imageUrl)} alt="Prifile Picture" className="prof-pic-prvw" />
                                                    :
                                                    <img style={{ cursor: 'pointer', }} onClick={onClickHandlePic} src={profimg} alt="Prifile Picture" className="prof-pic-prvw" />
                                                }
                                                <Typography align="center" variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                                                    {emailAdrs.current}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4} sx={{}}>
                                <Box sx={{ ml: 20 }} >
                                    <Stack direction="column">
                                        <Box sx={{ ml: 7 }} >
                                            <Button sx={{}} onClick={() => setSelectedSection(sections.personalInfo)}>
                                                <ContactsOutlinedIcon sx={{ color: '#616161', fontSize: 32 }} />
                                                <Typography variant="h6" sx={{ textTransform: 'none', ml: 2, fontWeight: 400 }} color="text.secondary">Personal Info</Typography>
                                            </Button>
                                        </Box>
                                        <Divider variant="fullWidth" component="div" sx={{ background: '#000', ml: 7, mt: 2, mb: 2 }} />
                                        <Box sx={{ ml: 7 }} >
                                            <Button sx={{ }} onClick={() => setSelectedSection(sections.changePassword)}>
                                                <HttpsOutlinedIcon sx={{ color: '#616161', fontSize: 32 }} />
                                                <Typography variant="h6" sx={{ textTransform: 'none', ml: 2, fontWeight: 400 }} color="text.secondary">Change Password</Typography>
                                            </Button>
                                        </Box>
                                        {/*    <Divider variant="fullWidth" component="div" sx={{ background: '#e0e0e0', ml: 5, mt: 2, mb: 2 }} />*/}
                                        {/*<Box sx={{ ml: 5 }} >*/}
                                        {/*    <Button sx={{ mr: 0, }} onClick={() => setSelectedSection(sections.recentActivity)}>*/}
                                        {/*            <AccessTimeOutlinedIcon width="24px" height="24px" sx={{ color: grey[700], fontSize: 28 }} />*/}
                                        {/*            <Typography variant="body1" sx={{ textTransform: 'none', ml: 2 }} color="text.secondary">Recent Activity</Typography>*/}
                                        {/*    </Button>*/}
                                        {/*    </Box>*/}
                                        <Divider variant="fullWidth" component="div" sx={{ background: '#000', ml: 7, mt: 2, mb: 2 }} />

                                        <Box sx={{ ml: 7 }} >
                                            <Button sx={{ }} onClick={() => setSelectedSection(sections.preferences)}>
                                                <FormatListBulletedOutlinedIcon width="24px" height="24px" sx={{ color: '#616161', fontSize: 32 }} />
                                                <Typography variant="h6" sx={{ textTransform: 'none', ml: 2, fontWeight: 400 }} color="text.secondary">Preferences</Typography>
                                            </Button>
                                        </Box>
                                        <Divider variant="fullWidth" component="div" sx={{ background: '#000', ml: 7, mt: 2, mb: 1 }} />
                                    </Stack>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                {/*<Box sx={{ ml: 20 }} >*/}
                                {
                                    (selectedSection === sections.personalInfo) ?
                                        <PersonalInfoSection userId={userId} sessionId={sessionId} disablerole={true} isadmin={false} />
                                        :
                                        (selectedSection === sections.changePassword) ?
                                            <ProfileChangePassword userId={userId} sessionId={sessionId} emailadrs={emailAdrs.current} />
                                            :
                                            (selectedSection === sections.recentActivity) ?
                                                <ProfileRecentActivity cntctid={userId} emailadrs={emailAdrs.current} />
                                                :
                                                (selectedSection === sections.preferences) ?
                                                    <ProfilePreferences userId={userId} sessionId={sessionId} emailadrs={emailAdrs.current} />
                                                :
                                            <div><h5>Invalid operation!!</h5></div>

                                }
                                {/*</Box>*/}
                            </Grid>
                        </Grid>
                    </Grid>
                    {showImageDlg ?
                        <ProfilePicUpdDlg open={showImageDlg} onClose={closeImageDlg} onChange={onPicChangeHandle} cntctid={userId} userId={userId} sessionId={sessionId} />
                        : null
                    }
                </Paper>
                <Footer />
            </Container>
        </React.Fragment>
    );

}

function UserProfileBreadcrumb() {
    return (
        <React.Fragment >
            <Box sx={{ borderLeft: '4px solid #9e9e9e', mt: 0, pt: 0, pb: 2, pl: 1, backgroundColor: '#fff', borderTop: '0px solid #dee2e6' }}>
                <Typography variant="h4" sx={{ fontWeight: 400, lineHeight: 1.1, pl: 2, textTransform: 'none' }} color="text.primary">Profile Information</Typography>
            </Box>
        </React.Fragment>
    );
}

export default UserProfileSetting;